import { Link, useSearchParams } from "react-router-dom";
import { Info, XCircle } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { Button } from "@/components/ui/button";

export default function BillingCancelledPage() {
  const [params] = useSearchParams();
  const deepLink = params.get("deep_link");

  return (
    <div className="mb-page flex min-h-screen items-center justify-center px-6 py-12" data-testid="billing-cancelled-page">
      <div className="w-full max-w-lg mb-rise">
        <div className="flex justify-center">
          <BrandLogo className="h-10" />
        </div>
        <div className="mt-12 rounded-2xl border border-gray-200 bg-white p-10 text-center shadow-mb-card">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
            <XCircle className="h-8 w-8 text-gray-500" />
          </div>
          <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Checkout cancelled.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-gray-500">
            No charge was made. You can pick up where you left off any time
            from the Billing page.
          </p>
          <div className="mx-auto mt-6 inline-flex max-w-sm items-start gap-2 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 text-left text-xs text-gray-500">
            <Info className="mt-0.5 h-3.5 w-3.5 flex-none text-gray-400" />
            <span>
              Your free trial (30 days OR 3 successful matches) keeps running
              until you upgrade — no gap in access.
            </span>
          </div>
          {deepLink && (
            <div className="mt-6 rounded-xl border border-gray-100 bg-gray-50 p-4 text-left">
              <div className="text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                Mobile deep link
              </div>
              <div
                className="mt-1 break-all font-mono text-xs text-gray-700"
                data-testid="mobile-deep-link"
              >
                {deepLink}
              </div>
            </div>
          )}
          <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
            <Link to="/dashboard/inventory">
              <Button
                type="button"
                variant="outline"
                className="mb-focus-ring h-11 rounded-xl border-gray-200 bg-white px-6 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                data-testid="cancelled-back-to-app"
              >
                Back to MatchBroker
              </Button>
            </Link>
            <Link to="/dashboard/billing">
              <Button
                type="button"
                className="mb-focus-ring h-11 rounded-xl bg-[#1B2B4B] px-6 text-sm font-semibold text-white hover:bg-[#14213A]"
                data-testid="cancelled-retry-upgrade"
              >
                Try again
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
